<template>
  <div class="live-upload-page">
    <!-- 左右布局容器 -->
    <div class="main-layout">
      <!-- 左侧：成为主播预览区 -->
      <div class="left-panel">
        <div class="card">
          <h3 class="card-title">成为主播</h3>
          <div class="video-area">
            <div class="video-player">
              <span class="video-tag">您还未实名认证！</span>
              <!-- <button class="btn-fill">填入播放地址</button> -->
            </div>
            <div class="video-ctrl">
              <!-- <button class="btn-copy" @click="copyUrl">复制推流地址</button> -->
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧：实名认证 + 直播间资料 -->
      <div class="right-panel">
        <!-- 实名认证 -->
        <div class="card auth-card">
          <h3 class="card-title">
            <span class="step-num">1</span>
            实名认证
            <span class="status-tag" :class="authStatus">{{ authStatusText }}</span>
          </h3>
          
          <!-- 未认证状态 -->
          <div v-if="authStatus === 'unverified'" class="auth-form">
            <!-- 认证说明 -->
            <div class="auth-notice">
              <h4>主播实名认证须知</h4>
              <ul>
                <li>根据《网络直播营销管理办法》，开播前必须完成实名认证</li>
                <li>请使用本人真实身份信息，平台将严格保密</li>
                <li>认证审核时间为1-3个工作日，请耐心等待</li>
                <li>每个身份证仅限认证一个主播账号</li>
              </ul>
            </div>
            
            <div class="form-row">
              <div class="form-col">
                <label>真实姓名 <span class="required">*</span></label>
                <input v-model="authForm.realName" type="text" placeholder="请输入真实姓名，需与身份证一致" />
              </div>
              <div class="form-col">
                <label>身份证号码 <span class="required">*</span></label>
                <input v-model="authForm.idCard" type="text" placeholder="请输入18位身份证号码" maxlength="18" />
              </div>
            </div>
            
            <div class="form-row">
              <div class="form-col">
                <label>手机号码 <span class="required">*</span></label>
                <input v-model="authForm.phone" type="text" placeholder="请输入本人手机号" maxlength="11" />
              </div>
              <div class="form-col">
                <label>紧急联系人电话 <span class="required">*</span></label>
                <input v-model="authForm.emergencyPhone" type="text" placeholder="用于紧急情况联系" maxlength="11" />
              </div>
            </div>
            
            <!-- 身份证上传 -->
            <div class="idcard-upload">
              <label>身份证照片上传 <span class="required">*</span></label>
              <div class="upload-row">
                <!-- 正面 -->
                <div class="idcard-frame">
                  <input 
                    type="file" 
                    ref="idCardFrontInput" 
                    accept="image/*" 
                    style="display: none;" 
                    @change="handleIdCardChange($event, 'front')"
                  />
                  <div v-if="!idCardFront" class="upload-placeholder" @click="triggerIdCardUpload('front')">
                    <i class="el-icon-plus"></i>
                    <span>身份证正面</span>
                    <small>点击上传</small>
                  </div>
                  <img v-else :src="idCardFront" class="idcard-preview" @click="triggerIdCardUpload('front')" />
                </div>
                <!-- 反面 -->
                <div class="idcard-frame">
                  <input 
                    type="file" 
                    ref="idCardBackInput" 
                    accept="image/*" 
                    style="display: none;" 
                    @change="handleIdCardChange($event, 'back')"
                  />
                  <div v-if="!idCardBack" class="upload-placeholder" @click="triggerIdCardUpload('back')">
                    <i class="el-icon-plus"></i>
                    <span>身份证反面</span>
                    <small>点击上传</small>
                  </div>
                  <img v-else :src="idCardBack" class="idcard-preview" @click="triggerIdCardUpload('back')" />
                </div>
                <!-- 手持 -->
                <div class="idcard-frame">
                  <input 
                    type="file" 
                    ref="idCardHoldInput" 
                    accept="image/*" 
                    style="display: none;" 
                    @change="handleIdCardChange($event, 'hold')"
                  />
                  <div v-if="!idCardHold" class="upload-placeholder" @click="triggerIdCardUpload('hold')">
                    <i class="el-icon-plus"></i>
                    <span>手持身份证</span>
                    <small>点击上传</small>
                  </div>
                  <img v-else :src="idCardHold" class="idcard-preview" @click="triggerIdCardUpload('hold')" />
                </div>
              </div>
              <div class="upload-tips">
                <p><i class="el-icon-warning-outline"></i> 照片要求：清晰、完整、无遮挡，文字可见，四角完整</p>
                <p><i class="el-icon-warning-outline"></i> 手持照要求：本人手持身份证，面部清晰，证件信息可见</p>
                <p><i class="el-icon-warning-outline"></i> 支持格式：JPG、PNG，单张不超过5MB</p>
              </div>
            </div>
            
            <button 
              class="btn-auth" 
              :class="{ 'btn-auth-disabled': !canSubmitAuth }"
              :disabled="!canSubmitAuth"
              @click="submitAuth"
            >
              提交认证
            </button>
          </div>
          
          <!-- 认证中状态 -->
          <div v-else-if="authStatus === 'pending'" class="auth-status">
            <div class="status-icon">⏳</div>
            <p class="status-text">实名认证审核中</p>
            <p class="status-desc">预计1-3个工作日完成审核，请耐心等待</p>
            <div class="status-detail">
              <p>提交时间：{{ submitTime }}</p>
              <p>审核结果将通过短信通知您</p>
            </div>
          </div>
          
          <!-- 已认证状态 -->
          <div v-else-if="authStatus === 'verified'" class="auth-status success">
            <div class="status-icon">✓</div>
            <p class="status-text">实名认证已通过</p>
            <p class="status-desc">{{ authForm.realName }} | {{ maskIdCard(authForm.idCard) }}</p>
            <div class="status-detail">
              <p>认证时间：{{ verifyTime }}</p>
              <p>您现在可以设置直播间资料了</p>
            </div>
          </div>
        </div>

        <!-- 直播间资料（仅认证通过后显示） -->
        <template v-if="authStatus === 'verified'">
          <div class="card">
            <h3 class="card-title">
              <span class="step-num">2</span>
              直播间资料
            </h3>
            
            <div class="info-form">
              <div class="form-row">
                <div class="form-col">
                  <label>主播昵称</label>
                  <input v-model="form.nickname" type="text" />
                </div>
                <div class="form-col">
                  <label>直播间名称</label>
                  <input v-model="form.roomName" type="text" />
                </div>
              </div>
              
              <div class="form-row">
                <div class="form-col">
                  <label>直播分类</label>
                  <div class="custom-select" @click="showCategoryDropdown = !showCategoryDropdown">
                    <span class="select-text">{{ form.category ? getCategoryLabel(form.category) : '请选择' }}</span>
                    <i class="el-icon-arrow-down"></i>
                    <div v-if="showCategoryDropdown" class="dropdown-menu">
                      <div
                        v-for="item in categoryList"
                        :key="item.value"
                        class="dropdown-item"
                        @click.stop="selectCategory(item.value)"
                      >
                        {{ item.label }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-col">
                  <label>直播间ID</label>
                  <input v-model="form.roomId" type="text" readonly />
                </div>
              </div>
              
              <div class="form-row">
                <div class="form-col full">
                  <label>直播间公告</label>
                  <input v-model="form.notice" type="text" placeholder="填写直播间公告，让观众更了解你" />
                </div>
              </div>
            </div>
          </div>

          <!-- 直播间封面 -->
          <div class="card">
            <h3 class="card-title">
              <span class="step-num">3</span>
              直播间封面
              <span class="tip">请根据直播比例选择图片上传</span>
            </h3>
            <div class="cover-box">
              <!-- 竖版封面 -->
              <div class="upload-frame frame-portrait">
                <input 
                  type="file" 
                  ref="fileInputV" 
                  accept="image/*" 
                  style="display: none;" 
                  @change="handleFileChange($event, 'portrait')"
                />
                <img v-if="coverPortrait" :src="coverPortrait" class="cover-preview" />
                <button v-else class="btn-upload" @click="triggerUpload('portrait')">上传图片</button>
                <div v-if="coverPortrait" class="cover-actions">
                  <button class="btn-reupload" @click="triggerUpload('portrait')">重新上传</button>
                </div>
              </div>
              <!-- 横版封面 -->
              <div class="upload-frame frame-landscape">
                <input 
                  type="file" 
                  ref="fileInputH" 
                  accept="image/*" 
                  style="display: none;" 
                  @change="handleFileChange($event, 'landscape')"
                />
                <img v-if="coverLandscape" :src="coverLandscape" class="cover-preview" />
                <button v-else class="btn-upload" @click="triggerUpload('landscape')">上传图片</button>
                <div v-if="coverLandscape" class="cover-actions">
                  <button class="btn-reupload" @click="triggerUpload('landscape')">重新上传</button>
                </div>
              </div>
            </div>
          </div>

          <!-- 提交 -->
          <div class="submit-box">
            <button 
              class="btn-submit" 
              :class="{ 'btn-submit-disabled': isSubmitting }"
              :disabled="isSubmitting"
              @click="submit"
            >
              {{ isSubmitting ? '审核中预计3~5个工作日' : '提交资料' }}
            </button>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LiveUploadPage',
  data() {
    return {
      // 实名认证状态: unverified-未认证 pending-审核中 verified-已认证
      authStatus: 'unverified',
      showCategoryDropdown: false,
      // 实名认证表单
      authForm: {
        realName: '',
        idCard: '',
        phone: '',
        emergencyPhone: ''
      },
      // 提交时间
      submitTime: '',
      verifyTime: '',
      // 身份证照片
      idCardFront: '',
      idCardBack: '',
      idCardHold: '',
      // 直播间表单
      form: {
        nickname: '',
        roomName: '',
        category: '',
        roomId: '3269',
        notice: ''
      },
      // 封面图片
      coverPortrait: '',
      coverLandscape: '',
      // 提交状态
      isSubmitting: false,
      categoryList: [
        { label: '音乐', value: 'music' },
        { label: '舞蹈', value: 'dance' },
        { label: '乐器', value: 'instrument' },
        { label: '脱口秀', value: 'talkshow' },
        { label: '二次元', value: 'anime' },
        { label: '颜值', value: 'beauty' },
        { label: '才艺', value: 'talent' },
        { label: '生活方式', value: 'lifestyle' },
        { label: '团舞', value: 'groupdance' },
        { label: '翻唱', value: 'cover' }
      ]
    }
  },
  computed: {
    // 认证状态文字
    authStatusText() {
      const map = {
        'unverified': '未认证',
        'pending': '审核中',
        'verified': '已认证'
      }
      return map[this.authStatus] || '未认证'
    },
    // 提交按钮文字
    submitBtnText() {
      if (this.authStatus !== 'verified') return '请先完成实名认证'
      if (this.isSubmitting) return '审核中预计3~5个工作日'
      return '提交资料'
    },
    // 是否可以提交实名认证
    canSubmitAuth() {
      // 验证真实姓名
      if (!this.authForm.realName.trim()) return false
      // 验证身份证号
      if (!this.authForm.idCard.trim()) return false
      const idCardReg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      if (!idCardReg.test(this.authForm.idCard)) return false
      // 验证手机号
      if (!this.authForm.phone.trim()) return false
      const phoneReg = /^1[3-9]\d{9}$/
      if (!phoneReg.test(this.authForm.phone)) return false
      // 验证紧急联系人
      if (!this.authForm.emergencyPhone.trim()) return false
      if (!phoneReg.test(this.authForm.emergencyPhone)) return false
      // 验证身份证照片
      if (!this.idCardFront || !this.idCardBack || !this.idCardHold) return false
      return true
    }
  },
  methods: {
    // 获取分类名称
    getCategoryLabel(value) {
      const item = this.categoryList.find(i => i.value === value)
      return item ? item.label : ''
    },
    // 选择分类
    selectCategory(value) {
      this.form.category = value
      this.showCategoryDropdown = false
    },
    // 复制推流地址
    copyUrl() {
      this.$message.success('推流地址已复制')
    },
    // 开始直播
    startLive() {
      this.$emit('startLive')
    },
    // 触发身份证上传
    triggerIdCardUpload(type) {
      if (type === 'front') {
        this.$refs.idCardFrontInput.click()
      } else if (type === 'back') {
        this.$refs.idCardBackInput.click()
      } else {
        this.$refs.idCardHoldInput.click()
      }
    },
    // 处理身份证照片选择
    handleIdCardChange(event, type) {
      const file = event.target.files[0]
      if (!file) return
      
      // 验证文件类型
      if (!file.type.startsWith('image/')) {
        this.$message.error('请上传图片文件')
        return
      }
      
      // 验证文件大小（最大5MB）
      if (file.size > 5 * 1024 * 1024) {
        this.$message.error('图片大小不能超过5MB')
        return
      }
      
      // 读取并预览图片
      const reader = new FileReader()
      reader.onload = (e) => {
        if (type === 'front') {
          this.idCardFront = e.target.result
        } else if (type === 'back') {
          this.idCardBack = e.target.result
        } else {
          this.idCardHold = e.target.result
        }
        this.$message.success('图片上传成功')
      }
      reader.readAsDataURL(file)
      
      // 清空input，允许重复选择同一文件
      event.target.value = ''
    },
    // 提交实名认证
    submitAuth() {
      // 验证真实姓名
      if (!this.authForm.realName.trim()) {
        this.$message.error('请输入真实姓名')
        return
      }
      // 验证身份证号
      if (!this.authForm.idCard.trim()) {
        this.$message.error('请输入身份证号码')
        return
      }
      // 简单身份证格式验证
      const idCardReg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      if (!idCardReg.test(this.authForm.idCard)) {
        this.$message.error('请输入正确的18位身份证号码')
        return
      }
      // 验证手机号
      if (!this.authForm.phone.trim()) {
        this.$message.error('请输入手机号码')
        return
      }
      const phoneReg = /^1[3-9]\d{9}$/
      if (!phoneReg.test(this.authForm.phone)) {
        this.$message.error('请输入正确的手机号码')
        return
      }
      // 验证紧急联系人
      if (!this.authForm.emergencyPhone.trim()) {
        this.$message.error('请输入紧急联系人电话')
        return
      }
      if (!phoneReg.test(this.authForm.emergencyPhone)) {
        this.$message.error('请输入正确的紧急联系人电话')
        return
      }
      // 验证身份证照片
      if (!this.idCardFront || !this.idCardBack || !this.idCardHold) {
        this.$message.error('请上传完整的身份证照片（正面、反面、手持）')
        return
      }

      // 记录提交时间
      this.submitTime = new Date().toLocaleString('zh-CN')
      
      this.$message.success('实名认证提交成功，正在审核中')
      this.authStatus = 'pending'
      
      // 模拟审核通过（实际应该等待后端回调）
      // setTimeout(() => {
      //   this.authStatus = 'verified'
      //   this.verifyTime = new Date().toLocaleString('zh-CN')
      //   this.$message.success('实名认证已通过')
      // }, 3000)
    },
    // 隐藏身份证号
    maskIdCard(idCard) {
      if (!idCard || idCard.length !== 18) return idCard
      return idCard.slice(0, 4) + '**********' + idCard.slice(14)
    },
    // 触发封面上传
    triggerUpload(type) {
      if (this.authStatus !== 'verified') {
        this.$message.warning('请先完成实名认证')
        return
      }
      if (type === 'portrait') {
        this.$refs.fileInputV.click()
      } else {
        this.$refs.fileInputH.click()
      }
    },
    // 处理封面文件选择
    handleFileChange(event, type) {
      const file = event.target.files[0]
      if (!file) return
      
      // 验证文件类型
      if (!file.type.startsWith('image/')) {
        this.$message.error('请上传图片文件')
        return
      }
      
      // 验证文件大小（最大5MB）
      if (file.size > 5 * 1024 * 1024) {
        this.$message.error('图片大小不能超过5MB')
        return
      }
      
      // 读取并预览图片
      const reader = new FileReader()
      reader.onload = (e) => {
        if (type === 'portrait') {
          this.coverPortrait = e.target.result
        } else {
          this.coverLandscape = e.target.result
        }
        this.$message.success('图片上传成功')
      }
      reader.readAsDataURL(file)
      
      // 清空input，允许重复选择同一文件
      event.target.value = ''
    },
    // 提交直播间资料
    submit() {
      if (this.authStatus !== 'verified') {
        this.$message.warning('请先完成实名认证')
        return
      }
      if (!this.form.nickname.trim()) {
        this.$message.error('请输入主播昵称')
        return
      }
      if (!this.form.roomName.trim()) {
        this.$message.error('请输入直播间名称')
        return
      }
      if (!this.form.category) {
        this.$message.error('请选择直播分类')
        return
      }
      this.$message.success('资料提交成功，审核需要3~5个工作日，请耐心等待')
      // 清空表单数据
      this.form.nickname = ''
      this.form.roomName = ''
      this.form.category = ''
      this.form.notice = ''
      // 清空封面图片
      this.coverPortrait = ''
      this.coverLandscape = ''
      // 设置提交状态为审核中
      this.isSubmitting = true
    }
  }
}
</script>

<style scoped lang="scss">
.live-upload-page {
  min-height: 100vh;
  background: #f5f5f5;
  padding: 16px;
}

// 左右布局
.main-layout {
  display: flex;
  gap: 16px;
  margin: 0 auto;
}

// 左侧面板
.left-panel {
  width: 60%;
  flex-shrink: 0;
  
  .card {
    height: calc(100vh - 32px);
    display: flex;
    flex-direction: column;
    margin-bottom: 0;
    
    .card-title {
      flex-shrink: 0;
    }
    
    .video-area {
      flex: 1;
      display: flex;
      flex-direction: column;
      
      .video-player {
        flex: 1;
        margin-bottom: 0;
      }
    }
  }
}

// 右侧面板
.right-panel {
  flex: 1;
  min-width: 0;
}

.card {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 12px;
  transition: opacity 0.3s ease;
  
  &.disabled {
    opacity: 0.6;
    pointer-events: none;
  }
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0 0 16px 0;
  display: flex;
  align-items: center;
  gap: 8px;

  .step-num {
    width: 24px;
    height: 24px;
    background: #8B5CF6;
    color: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 600;
  }

  .tip {
    font-size: 12px;
    color: #999;
    font-weight: normal;
    margin-left: 8px;
  }
  
  .status-tag {
    font-size: 12px;
    padding: 2px 10px;
    border-radius: 12px;
    font-weight: normal;
    margin-left: auto;
    
    &.unverified {
      background: #fef3c7;
      color: #d97706;
    }
    
    &.pending {
      background: #dbeafe;
      color: #2563eb;
    }
    
    &.verified {
      background: #d1fae5;
      color: #059669;
    }
  }
  
  .lock-tip {
    font-size: 12px;
    color: #999;
    font-weight: normal;
    margin-left: auto;
  }
}

// 视频区域
.video-area {
  .video-player {
    width: 100%;
    aspect-ratio: 16 / 9;
    background: #000;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    margin-bottom: 12px;

    .video-tag {
      padding: 6px 16px;
      background: rgba(255, 255, 255, 0.15);
      border-radius: 16px;
      color: rgba(255, 255, 255, 0.8);
      font-size: 16px;
      margin-bottom: 60px;
    }

    .btn-fill {
      position: absolute;
      bottom: 30px;
      padding: 8px 24px;
      background: #4a4a4a;
      border: none;
      border-radius: 16px;
      color: #fff;
      font-size: 13px;
      cursor: pointer;

      &:hover {
        background: #555;
      }
    }
  }

  .video-ctrl {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .btn-copy {
      padding: 8px 20px;
      background: #fff;
      border: 1px solid #e0e0e0;
      border-radius: 16px;
      color: #666;
      font-size: 13px;
      cursor: pointer;

      &:hover {
        background: #f8f8f8;
      }
    }

    .btn-start {
      padding: 10px 28px;
      background: #8B5CF6;
      border: none;
      border-radius: 20px;
      color: #fff;
      font-size: 14px;
      cursor: pointer;

      &:hover {
        opacity: 0.9;
      }
    }
  }
}

// 实名认证卡片
.auth-card {
  min-height: calc(100vh - 32px);
  display: flex;
  flex-direction: column;
  
  .card-title {
    flex-shrink: 0;
  }
  
  .auth-form {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}

// 认证须知
.auth-notice {
  background: #fefce8;
  border: 1px solid #fde047;
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 20px;
  
  h4 {
    font-size: 14px;
    color: #854d0e;
    margin: 0 0 10px 0;
    font-weight: 600;
  }
  
  ul {
    margin: 0;
    padding-left: 18px;
    
    li {
      font-size: 13px;
      color: #a16207;
      line-height: 1.8;
    }
  }
}

// 实名认证表单
.auth-form {
  .form-row {
    display: flex;
    gap: 16px;
    margin-bottom: 16px;
  }
  
  .form-col {
    flex: 1;
    
    label {
      display: block;
      font-size: 13px;
      color: #333;
      margin-bottom: 8px;
      
      .required {
        color: #ef4444;
        margin-left: 2px;
      }
    }

    input {
      width: 100%;
      padding: 10px 16px;
      border: 1px solid #e8e8e8;
      border-radius: 8px;
      font-size: 14px;
      color: #333;
      background: #fafafa;
      outline: none;
      box-sizing: border-box;

      &:focus {
        border-color: #8B5CF6;
      }

      &::placeholder {
        color: #aaa;
      }
    }
  }
}

// 身份证上传
.idcard-upload {
  margin-bottom: 16px;
  
  label {
    display: block;
    font-size: 13px;
    color: #333;
    margin-bottom: 12px;
    
    .required {
      color: #ef4444;
      margin-left: 2px;
    }
  }
  
  .upload-row {
    display: flex;
    gap: 16px;
  }
  
  .idcard-frame {
    flex: 1;
    aspect-ratio: 1.58;
    border: 2px dashed #d0d8ff;
    border-radius: 8px;
    background: #f0f2ff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    overflow: hidden;
    transition: all 0.2s ease;
    
    &:hover {
      border-color: #8B5CF6;
      background: #e8ecff;
    }
    
    .upload-placeholder {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;
      color: #666;
      
      i {
        font-size: 24px;
        color: #8B5CF6;
      }
      
      span {
        font-size: 13px;
      }
      
      small {
        font-size: 11px;
        color: #999;
      }
    }
    
    .idcard-preview {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  
  .upload-tips {
    margin-top: 12px;
    padding: 12px 16px;
    background: #f8fafc;
    border-radius: 6px;
    
    p {
      font-size: 12px;
      color: #64748b;
      margin: 0 0 6px 0;
      display: flex;
      align-items: center;
      gap: 6px;
      
      &:last-child {
        margin-bottom: 0;
      }
      
      i {
        color: #f59e0b;
      }
    }
  }
}

// 认证状态
.auth-status {
  text-align: center;
  padding: 40px 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  
  .status-icon {
    font-size: 56px;
    margin-bottom: 16px;
  }
  
  .status-text {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 0 0 8px 0;
  }
  
  .status-desc {
    font-size: 14px;
    color: #666;
    margin: 0 0 20px 0;
  }
  
  .status-detail {
    background: #f8fafc;
    border-radius: 8px;
    padding: 16px 24px;
    margin-top: 10px;
    
    p {
      font-size: 13px;
      color: #64748b;
      margin: 0 0 6px 0;
      
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  
  &.success {
    .status-icon {
      color: #059669;
    }
  }
}

// 提交认证按钮
.btn-auth {
  width: 100%;
  padding: 14px;
  background: #8B5CF6;
  border: none;
  border-radius: 8px;
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  margin-top: auto;
  
  &:hover:not(:disabled) {
    opacity: 0.9;
  }
  
  &.btn-auth-disabled {
    background: #d1d5db;
    cursor: not-allowed;
  }
}

// 直播间资料表单
.info-form {
  .form-row {
    display: flex;
    gap: 16px;
    margin-bottom: 16px;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
  
  .form-col {
    flex: 1;
    
    &.full {
      flex: 1;
    }
    
    label {
      display: block;
      font-size: 13px;
      color: #333;
      margin-bottom: 8px;
    }

    input {
      width: 100%;
      padding: 10px 16px;
      border: 1px solid #e8e8e8;
      border-radius: 8px;
      font-size: 14px;
      color: #333;
      background: #fafafa;
      outline: none;
      box-sizing: border-box;

      &:focus {
        border-color: #8B5CF6;
      }

      &[readonly] {
        background: #f5f5f5;
        color: #999;
      }
      
      &:disabled {
        background: #f5f5f5;
        color: #999;
        cursor: not-allowed;
      }
    }

    // 自定义下拉框
    .custom-select {
      position: relative;
      width: 100%;
      padding: 10px 16px;
      border: 1px solid #e8e8e8;
      border-radius: 8px;
      font-size: 14px;
      color: #333;
      background: #fafafa;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;

      .select-text {
        color: #333;
      }

      .el-icon-arrow-down {
        color: #999;
        font-size: 12px;
      }

      .dropdown-menu {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        margin-top: 4px;
        background: #fff;
        border: 1px solid #e8e8e8;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        z-index: 100;
        max-height: 200px;
        overflow-y: auto;

        .dropdown-item {
          padding: 10px 16px;
          font-size: 14px;
          color: #333;
          cursor: pointer;
          transition: background 0.2s ease;

          &:hover {
            background: #f5f5f5;
          }

          &:first-child {
            border-radius: 8px 8px 0 0;
          }

          &:last-child {
            border-radius: 0 0 8px 8px;
          }
        }
      }
      
      &.disabled {
        background: #f5f5f5;
        color: #999;
        cursor: not-allowed;
      }
    }
  }
}

// 封面区域 - 淡紫色背景
.cover-box {
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  padding: 40px 60px;
  display: flex;
  gap: 60px;
  justify-content: center;
  align-items: center;
  background: #e8ecff;

  .upload-frame {
    border: 1px solid #d0d8ff;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #f0f2ff;
    position: relative;
    overflow: hidden;

    &.frame-portrait {
      width: 200px;
      height: 300px;
    }

    &.frame-landscape {
      width: 360px;
      height: 200px;
    }

    .cover-preview {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 8px;
    }

    .cover-actions {
      position: absolute;
      bottom: 10px;
      left: 50%;
      transform: translateX(-50%);
    }

    .btn-upload {
      padding: 10px 40px;
      background: #9ca3af;
      border: none;
      border-radius: 20px;
      color: #fff;
      font-size: 13px;
      cursor: pointer;

      &:hover:not(:disabled) {
        background: #6b7280;
      }
      
      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }

    .btn-reupload {
      padding: 6px 20px;
      background: rgba(139, 92, 246, 0.9);
      border: none;
      border-radius: 16px;
      color: #fff;
      font-size: 12px;
      cursor: pointer;

      &:hover {
        background: rgba(139, 92, 246, 1);
      }
    }
  }
}

// 提交
.submit-box {
  display: flex;
  justify-content: center;
  padding: 8px 0;

  .btn-submit {
    padding: 12px 48px;
    background: #8B5CF6;
    border: none;
    border-radius: 24px;
    color: #fff;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;

    &:hover:not(:disabled) {
      opacity: 0.9;
    }

    &.btn-submit-disabled {
      background: #9ca3af;
      cursor: not-allowed;

      &:hover {
        opacity: 1;
      }
    }
  }
}
</style>